import React from "react";
import { sortBy } from "lodash";

import Grid from "@mui/material/Grid2";

import { DemographicCard } from "@/components/atoms";
import { InsightResult } from "@/types";

interface DemographicsSectionProps {
  insights: InsightResult[];
  score: string;
  compareMode?: boolean;
  gradient?: string[];
}

const DemographicsSection: React.FC<DemographicsSectionProps> = ({
  insights,
  score,
  compareMode,
  gradient
}) => {
  const demographics = ["Age Band", "Income Band", "Lifestage"];

  const getDemographicValues = (demographic: string) => {
    const demographics = insights.filter((x) => x.tag_type === "Demographics");
    return sortBy(
      demographics.filter((x) => x.tag_category === demographic),
      "tag_id"
    );
  };

  return (
    <>
      {demographics.map((demographic, index) => {
        const values = getDemographicValues(demographic);

        return (
          <Grid
            size={
            compareMode ?
              {
                sm: 12,
                md: 12,
                lg: 12,
                xl: 4
              } :
              4
            }
            key={index}
          >
            <DemographicCard
              demographic={demographic}
              values={values}
              score={score}
              center={compareMode}
              gradient={gradient}
            />
          </Grid>
        );
      })}
    </>
  );
};

export default DemographicsSection;
